import { render, staticRenderFns } from "./RejectionReasonField.vue?vue&type=template&id=02ccc316&scoped=true"
import script from "./RejectionReasonField.vue?vue&type=script&lang=js"
export * from "./RejectionReasonField.vue?vue&type=script&lang=js"
import style0 from "./RejectionReasonField.vue?vue&type=style&index=0&id=02ccc316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ccc316",
  null
  
)

export default component.exports